import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { sentry } from 'sentry';
import { MfaService } from '../../../services/mfa.service';
var InsertPasswordComponent = /** @class */ (function () {
    function InsertPasswordComponent(mfaService, fuseProgressBarService) {
        this.mfaService = mfaService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.showPassword = false;
        this.back = new EventEmitter();
        this.next = new EventEmitter();
        this.passwordControl = new FormControl(null, [Validators.required]);
    }
    InsertPasswordComponent.prototype.generateTemporaryToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var input, temporaryToken, err_1, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.isLoading = true;
                        this.fuseProgressBarService.show();
                        input = { password: this.passwordControl.value };
                        return [4 /*yield*/, this.mfaService.regenerateToken(input)];
                    case 1:
                        temporaryToken = _a.sent();
                        this.isLoading = false;
                        this.fuseProgressBarService.hide();
                        this.next.emit(temporaryToken);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        this.isLoading = false;
                        this.fuseProgressBarService.hide();
                        code = getErrorCode(err_1);
                        if (code === 'NotAuthorizedException') {
                            this.passwordControl.setErrors({ incorrect: true });
                            return [2 /*return*/];
                        }
                        sentry.captureException(err_1, {
                            extra: {
                                message: 'Error on insert password to generate temporary token',
                                err: JSON.stringify(err_1)
                            }
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return InsertPasswordComponent;
}());
export { InsertPasswordComponent };
